<img
  [src]="src$ | async"
  [ngStyle]="{
  'height': (height ? height + 'px' : null),
}"
  [alt]="alt"
  [class]="imgClass"
/>
